/**
 * A rota faz parte do ambiente administrativo do super-admin?
 *
 * Regra por **prefixo de segmento** (`adm-*`), e não por lista fixa. A lista fixa que vivia no
 * `Top.tsx` é a prova do problema: ela nunca recebeu `adm-gestao-tenants`, então o `Top` gravava
 * `adm = ''` justamente enquanto o usuário estava naquela tela — e um F5 ali fazia o `routes.tsx`
 * ler `adm === ''`, deixar de declarar a rota e entregar tela em branco. Toda tela `/adm-*` nova
 * repetiria o bug até alguém lembrar de editar a lista.
 *
 * `organizacao` NÃO entra aqui de propósito: é o seletor de empresa, onde o usuário comum ainda
 * não escolheu o tenant. Ele não é ambiente administrativo, e incluí-lo faria o app tratar
 * qualquer usuário como se estivesse na área do super-admin ao passar por essa tela.
 */
const SEGMENTOS_ADMINISTRATIVOS = ['administrador', 'admin', 'new-user-adm']

export const ehRotaAdministrativa = (pathname: string): boolean =>
  pathname
    .split('/')
    .some(
      segmento =>
        segmento.startsWith('adm-') ||
        SEGMENTOS_ADMINISTRATIVOS.includes(segmento)
    )
